import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cc0e4b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item__header" }
const _hoisted_2 = { class: "item__value" }

import { IonList, IonListHeader, IonItem, IonLabel, } from '@ionic/vue';
import { TProduct } from '@/const/types/product';
import { TPlace } from '@/const/types/place';
import { TCombination } from '@/const/types/combination';
import { TDocument } from '@/const/types/documents';
import { ref, computed } from 'vue';
import { TPackage } from '@/const/types/package';

type TModel = TPackage | TPlace | TCombination | TProduct | TDocument 

interface Props {
  model: TModel;
  modelName?: string;
  hideKeys?: (keyof TModel)[];
  additionalKeys?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicModelBasicInfoList',
  props: {
    model: null,
    modelName: null,
    hideKeys: null,
    additionalKeys: null
  },
  setup(__props: any) {

const props = __props as {
  model: TModel;
  modelName?: string;
  hideKeys?: (keyof TModel)[];
  additionalKeys?: string[];
};



const basicKeysToDisplay = ref<(keyof TModel)[]>(['id', 'code', 'external_id', 'created_at', 'updated_at'])
const additionalKeysToDisplay = computed(() => (props.additionalKeys ?? []).filter(key => key in props.model))
const keysToDisplay = computed(() => [ ...additionalKeysToDisplay.value, ...basicKeysToDisplay.value.filter(key => !((props.hideKeys ?? []).includes(key)))])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonList), null, {
    default: _withCtx(() => [
      (props.modelName)
        ? (_openBlock(), _createBlock(_unref(IonListHeader), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.modelName) + " information: ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keysToDisplay), (key) => {
        return (_openBlock(), _createBlock(_unref(IonItem), { key: key }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { class: "item__inner" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_1, _toDisplayString(key) + ": ", 1),
                _createElementVNode("p", _hoisted_2, _toDisplayString(props.model[key] ?? ' - '), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 3
  }))
}
}

})